import React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./css/productivityChart.css";

const ProductivityChart = (props) => {
  return (
    <div>
      <Card className="chart-card">
        <CardHeader
          data-testid="chart-header-Id"
          subheader={props.title}
          className="chart-header"
          titleTypographyProps={{ variant: 'body1' }}
        />
        <CardContent className="chart-content">
          <ResponsiveContainer width={"100%"} height={270}>
            <BarChart
              width={500}
              height={220}
              data={props.data}
            >
              <CartesianGrid vertical={false} /> {/* Solid line */}
              <XAxis
                label={{ dy: 300 }}
                dataKey="name"
                className="xaxis-label"
                interval={0}
                axisLine={false}
                tickLine={false}
                angle={-60}
                textAnchor="end"
              />
              <Legend wrapperStyle={{ bottom: -25 }} />
              <YAxis
                label={{ value: props.values.yAxisLabel, angle: -90, dy: 10, dx: -30 }}
                interval={0}
                className="yaxis-label"
                axisLine={false}
                tickLine={false}
              />
              <Tooltip 
                wrapperStyle={{ fontSize: "12px", padding: "4px", zIndex: 1000 }} 
              />
              <Legend />
              <Bar
                data-testid="chart-bar1-id"
                name={props.values.line1Plot}
                dataKey={props.values.line1DataKey}
                fill={props.values.line1Color}
                // stroke="#000000" // Uncomment if you want borders
                // strokeWidth={2}  // Uncomment if you want thicker borders
              />
              <Bar
                data-testid="chart-bar2-id"
                name={props.values.line2Plot}
                dataKey={props.values.line2DataKey}
                fill={props.values.line2Color}
                // stroke="#000000" // Uncomment if you want borders
                // strokeWidth={2}  // Uncomment if you want thicker borders
              />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
};

ProductivityChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  values: PropTypes.shape({
    yAxisLabel: PropTypes.string.isRequired,
    line1Plot: PropTypes.string.isRequired,
    line1DataKey: PropTypes.string.isRequired,
    line1Color: PropTypes.string.isRequired,
    line2Plot: PropTypes.string.isRequired,
    line2DataKey: PropTypes.string.isRequired,
    line2Color: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProductivityChart;